import { ArnClientError } from './ArnClientError';

export class UserRejectionError extends ArnClientError {
  constructor(message = 'User rejected action', cause?: any) {
    super(message, cause);
  }
}
